/**
 * Wheel game plugin
 * Provides spin wheel game functionality with customizable appearance and behavior
 */

export * from './wheel.plugin';
export * from './wheel-renderer';
export * from './wheel-configurator';
export * from './wheel-config-mapper';
